/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from "./actionTypes";
import moment from "moment";

const initilaState = {
  invoiceNumber: "",
  rebateProgramCode: {},
  errorMessages: [],
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_REBATE_PROGRAMS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case actionTypes.SET_SUSPENDED_DT_DATA: {
      return { ...state, suspendedDtData: action.payload };
    }
    case actionTypes.CHECKLOG_DATA: {
      return { ...state, checkLogData: action.payload };
    }
    case actionTypes.SET_ERROR_MESSAGES: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.RESET_REMOVE_SUSPENDED_DATE_STORE: {
      return { ...initilaState };
    }

    default:
      return state;
  }
};

export default reducer;
